/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from 'react';
import CheckboxNew from '../../../../components/CheckboxNew';
import MerchantDropdown from '../../../../components/MerchantDropdown';
import ListIcon from '../../../../svgs/ListIcon';
import Styles from './RoleCard.module.scss';

interface IRoleCard{
  data:any;
  handleDropdown:any;
  handleCheckCard?:any;
  hideCheckBox?:boolean;
}
const RoleCard = ({
  data, handleDropdown, handleCheckCard, hideCheckBox,
}:IRoleCard) => {
  const toggleRef = useRef<HTMLDivElement>(null);
  const [toggleDropdown, setToggleDropdown] = useState(false);

  const handleHideDropdown = (e) => {
    if (toggleRef?.current?.contains(e.target)) {
      return;
    }

    setToggleDropdown(false);
  };

  useEffect(() => {
    window.addEventListener('click', handleHideDropdown);
    return () => {
      window.removeEventListener('click', handleHideDropdown);
    };
  }, []);

  const handleOpenModal = () => {
    setToggleDropdown(!toggleDropdown);
  };

  return (
    <div className={Styles.wrapper}>
      <div className={Styles.wrapper__titleAndCheck}>
        <div className={Styles.wrapper__title}>{data?.name}</div>
        <div className={Styles.wrapper__check}>
          {!hideCheckBox && <CheckboxNew isLeftContent width="100%" name="" value={data?.checked} iconColor="white" backgroundColor={data?.checked ? 'rgba(89, 65, 169, 1)' : 'white'} height="fit-content" onChange={() => handleCheckCard(data)} onClick={() => handleCheckCard(data)} />}

        </div>
      </div>
      <div className={Styles.wrapper__body}>
        <div className={Styles.wrapper__activeContainer}>
          <div className={Styles.wrapper__label}>Active users</div>
          <div className={Styles.wrapper__value}>{data?.activeUser}</div>
        </div>
        <div className={Styles.wrapper__inActiveContainer}>
          <div className={Styles.wrapper__label}>Inactive users</div>
          <div className={Styles.wrapper__value}>{data?.inActiveUser}</div>
        </div>
      </div>
      <div className={Styles.wrapper__footer}>
        <div className={Styles.wrapper__footerStatus}>
          {
            data?.status ? <div className={data?.status === 'Active' ? Styles.wrapper__activeStatus : Styles.wrapper__inActiveStatus}>{data?.status}</div> : ''
          }
        </div>
        <div className={Styles.wrapper__footerIcon}>
          <div className={Styles.wrapper__footerIconContainer} ref={toggleRef} onClick={() => handleOpenModal()}><ListIcon /></div>
          {
            toggleDropdown && data?.dropdown && (
            <div className={Styles.wrapper__footerDropdown}>
              <MerchantDropdown data={data?.dropdown} hasWrapper handleDropdown={(dropdownTitle) => handleDropdown(dropdownTitle, data)} />
            </div>
            )
          }

        </div>
      </div>

    </div>
  );
};

export default RoleCard;
